module.exports = __webpack_public_path__ + "static/media/vasvi_gupta.fbf4c70d.jpg";